// height in pixels
export enum PANEL_HEIGHT {
  S = 160,
  M = 220,
  L = 260,
  XL = 280,
}
